export const PHONE_PATTERN = /^\s*\+?([- ]*\d[- ]*){9,}\s*$/;

export function isValidPhone(phone: string) : boolean {
  return PHONE_PATTERN.test(phone);
}

export function isEmptyOrValidPhone(phone?: string|null) : boolean {
  return phone ? PHONE_PATTERN.test(phone) : true;
}
